import { render, staticRenderFns } from "./practitioner-hours.vue?vue&type=template&id=98cd7ac8&"
import script from "./practitioner-hours.vue?vue&type=script&lang=ts&"
export * from "./practitioner-hours.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports